import { HawkWidgetAdvanced } from './HawkWidgetAdvanced';

export { HawkWidgetAdvanced } from './HawkWidgetAdvanced';

// We keep old export to keep backwards compatibillity
export default HawkWidgetAdvanced;
